export const CURRENT_MAP_AREA_COPY = 'Current Map Area';
